export enum TickerDirection {
  NORMAL = 'normal',
  REVERSED = 'reversed',
}

export enum TickerType {
  TEXT_TICKER = 'text',
  LOGO_TICKER = 'logo',
}